import { useSelector } from 'react-redux';

import { SusyModal, SusyModalProps } from '../susyModal/SusyModal';
import { RootState } from '../../../../store';
import { Loader } from '../../loader/Loader';
import SusyButton from '../../buttons/SusyButton';
import { ButtonKind } from '../../buttons/SusyButtonDefinitions';

import './ConfirmationModal.css';

interface ConfirmationModalProps extends SusyModalProps {
    onConfirm: () => void;
    confirmButtonDisabled?: boolean;
    confirmButtonText?: string;
    confirmButtonTestId?: string;
    confirmButtonKind?: ButtonKind;
    cancelButtonText?: string;
    cancelButtonTestId?: string;
    icon?: string;
    withBackground?: boolean;
    loading?: boolean;
    hideCancelButton?: boolean;
}

export const ConfirmationModal = (props: ConfirmationModalProps) => {
    const localization = useSelector(
        (state: RootState) =>
            state.localization.localizationStrings.susy.shared.modals
                .confirmationModal
    );

    const confirmationModalBody = (
        <>
            {props.icon && !props.withBackground && (
                <div className={'text-center'}>
                    <img src={props.icon} alt='icon' />
                </div>
            )}
            {props.icon && props.withBackground && (
                <div className={'rectangle d-flex ml-auto mr-auto mb-4'}>
                    <img
                        className={'ml-auto mr-auto logo'}
                        src={props.icon}
                        alt='icon'
                    />
                </div>
            )}

            {props.modalBody}
        </>
    );

    const confirmationModalFooter = (
        <>
            {!props.hideCancelButton ? (
                <>
                    <SusyButton
                        text={props.cancelButtonText ?? localization.cancel}
                        kind='ghost'
                        onClickHandler={props.onHide}
                        dataTestId={props.cancelButtonTestId}
                        htmlAttributes={{
                            disabled: props.loading,
                        }}
                    />
                    <SusyButton
                        text={props.confirmButtonText ?? localization.confirm}
                        kind={props.confirmButtonKind}
                        onClickHandler={props.onConfirm}
                        dataTestId={props.confirmButtonTestId}
                        htmlAttributes={{
                            disabled:
                                props.loading || props.confirmButtonDisabled,
                        }}
                        loading={props.loading}
                    />
                </>
            ) : (
                <SusyButton
                    text={
                        props.loading
                            ? ''
                            : props.confirmButtonText ?? localization.confirm
                    }
                    kind={props.confirmButtonKind}
                    onClickHandler={props.onConfirm}
                    dataTestId={props.confirmButtonTestId}
                    icon={props.loading ? <Loader /> : undefined}
                    htmlAttributes={{
                        disabled: props.confirmButtonDisabled,
                    }}
                />
            )}
        </>
    );

    return (
        <SusyModal
            title={props.title}
            showModal={props.showModal}
            dataTestId={props.dataTestId}
            modalBody={confirmationModalBody}
            modalFooter={confirmationModalFooter}
            onHide={props.onHide}
            size={props.size}
            notCloseOnOutsideClick={props.notCloseOnOutsideClick}
            subModal={props.subModal}
            scrollable={props.scrollable}
        ></SusyModal>
    );
};
